import { actionRegisterIn } from '../actions/loginActions';
import { setError } from '../reducers/_dispatchers';

const cantLoginIt = ()=> {
    setError();
};

export const getMyFbData = ()=> {
    window.FB.api('/me', {fields: 'name,last_name,email'}, function(response) {
        actionRegisterIn(response);
    });
}

export const fbCheckLogin = (response)=> {
    if(response) {
        const { status, authResponse } = response;
        if(status && status === 'connected' &&
            authResponse && authResponse.accessToken) {
            getMyFbData();
        } else {
            cantLoginIt();
        }
    } else {
        cantLoginIt();
    }
};

export const fbLogin = ()=> {
    if(typeof window.FB !== 'undefined') {
        window.FB.login(function(response) {
            fbCheckLogin(response);
        }, {scope: 'public_profile,email'});
    } else {
        setTimeout(() => {
            fbLogin();
        }, 500);
    }
};
